export default "__VITE_ASSET__CWbXya70__"